import { defineStore } from 'pinia'
import type { AppConfig } from '@/types/app'
import { getAppInfo } from '@/api/app'
import {
  getOrdernumber,
  getToken,
  setOrdernumber,
  setToken,
} from 'common/utils/cookies'
import dayjs from 'dayjs'
import { logApiError } from 'common/utils/firebase/utils'

const sanitizeUrl = (url: unknown): string => {
  if (typeof url !== 'string') return ''
  const trimmed = url.trim()
  if (!trimmed) return ''
  // 线上后端拼接错误会在 URL 首尾带反引号，统一去除
  return trimmed.replace(/^`+|`+$/g, '')
}

const sanitizeConfig = (config: any): AppConfig => ({
  ...config,
  icon: sanitizeUrl(config?.icon),
  logo: sanitizeUrl(config?.logo),
  site_logo: sanitizeUrl(config?.site_logo),
  return_url: sanitizeUrl(config?.return_url),
})

const storeKey = 'app'
export default defineStore(storeKey, {
  state: () => {
    return {
      config: {
        return_url: '',
        use_upstream_api: 0,
      } as AppConfig,
    }
  },
  getters: {
    returnUrl(state) {
      return state.config.return_url || ''
    },
  },
  actions: {
    init(token?: string, language = 'en', ordernumber = '') {
      if (language !== 'en') {
        dayjs.tz.setDefault('Asia/Bangkok')
      }
      const realToken = token || getToken()
      const realOrdernumber = ordernumber || getOrdernumber()|| ''
      if (realToken) {
        setToken(realToken)
        setOrdernumber(realOrdernumber)
        getAppInfo()
          .then((res) => {
            if (res) {
              this.config = sanitizeConfig(res)
            }
          })
          .catch((err) => {
            logApiError(err)
          })
      }
    },
  },
  persist: [
    {
      storage: sessionStorage,
      paths: ['config'],
    },
  ],
})
